// extracted by mini-css-extract-plugin
export default {"close":"Close_close__ouLZK","x":"Close_x__AfSgG"};